import { styled } from "@/styles/theme"

export default styled("label", {
  letterSpacing: "$3",
  fontSize: "$sm",
  fontWeight: "$medium",
  display: "inline-block",
  marginBottom: "4px",
})
